import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.EmptyState

const EmptyStateParts = [
  'container',
  'icon',
  'textContainer',
  'primaryText',
  'secondaryText',
] as const

const helpers = createMultiStyleConfigHelpers(EmptyStateParts)
export const EmptyStateStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingY: '2.5rem',
      gap: '1rem',
    },
    icon: {
      boxSize: '3.5rem',
      color: Colors.Icon,
    },
    textContainer: {
      flexDirection: 'column',
      paddingY: '0.5rem',
      paddingX: '1.5rem',
      gap: '0.5rem',
    },
    primaryText: {
      textStyle: textStyleKeys.Body1_Bold,
      textAlign: 'center',
      color: Colors.PrimaryText.FontColor,
    },
    secondaryText: {
      textStyle: textStyleKeys.Body2,
      textAlign: 'center',
      color: Colors.SecondaryText.FontColor,
    },
  },
})

export const useEmptyStateStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof EmptyStateParts>(
    getName({ EmptyStateStyle }),
    props,
  )
}
